import {
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Grid,
    Typography,
} from '@material-ui/core';
import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import WidgetCard from './WidgetCard';
import {useTheme} from '@material-ui/core/styles';
import moment from 'moment';
import {PageTab} from 'components';
import content from 'components/widgets/tooltips/InfoModalContent';
import InfoModal from 'components/widgets/tooltips/InfoModal';
import {useGetMMLDPassive} from 'hooks/useGetEndpoint';
import TimeLeft from './TimeLeft';

const useStyles = makeStyles(theme => ({
    table: {},
    tableHeader: {
        paddingRight: '.5rem',
        paddingLeft: '.5rem',
        width: 4,
    },
    tableCell: {
        paddingRight: '.5rem',
        paddingLeft: '.5rem',
        width: 4,
    },
    unsubmittedTableHeader: {
        paddingRight: '.5rem',
        paddingLeft: '.5rem',
        width: 4,
    },
    unsubmittedTableCell: {
        paddingRight: '.5rem',
        paddingLeft: '.5rem',
        width: 4,
    },
    gridWrapper: {
        display: 'flex',
    },
}));

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.gray.light2,
        },
        '&:hover': {
            backgroundColor: theme.palette.gray.main,
            cursor: 'pointer',
        },
        '& td a': {
            textDecoration: 'none',
        },
    },
}))(TableRow);

const SeaServiceUpcomingDates = ({expirationDates}) => {
    const {
        data: mmld,
        isLoading: isLoadingMmld,
        error: errorMmld,
    } = useGetMMLDPassive();
    const {
        data: dataExpiration,
        isLoading: isLoadingExpiration,
        error: errorExpiration,
    } = expirationDates;

    const theme = useTheme();
    const classes = useStyles();

    function ColumnHeaders() {
        const column_names = ['Credential', 'Issued', 'Renew By'];
        return column_names.map(name => (
            <TableCell className={classes.tableHeader} key={name}>
                <Typography variant='body1' style={{fontWeight: '500'}}>
                    {name}
                </Typography>
            </TableCell>
        ));
    }

    function UnsubmittedColumnHeaders() {
        const column_names = ['Document', 'Issued', 'Submit to USCG before'];
        return column_names.map(name => (
            <TableCell className={classes.unsubmittedTableHeader} key={name}>
                <Typography variant='body1' style={{fontWeight: '500'}}>
                    {name}
                </Typography>
            </TableCell>
        ));
    }

    // Below is first function to get STCW/Pilot Medical Objects
    const filterStcw = mmld => {
        return mmld?.recent_mmld_meta
            ?.filter(obj => obj.DOCUMENT_TYPE === 'MEDICAL CERTIFICATE')
            ?.map(ob => {
                const expiresInDays =
                    (new Date(ob.MC_STCW_EXPIRE_DT) - new Date()) /
                    (1000 * 3600 * 24);

                let color;

                if (expiresInDays < 30) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }

                return {
                    name: 'STCW/Pilot Medical',
                    issued: ob.DOCUMENT_ISSUED_DT,
                    renewBy: ob.MC_STCW_EXPIRE_DT,
                    bgColor: color,
                };
            });
    };
    let filterStcwResult = filterStcw(mmld) || [];

    //Below is 2nd Function used to get National Medical Objects
    const filterNational = mmld => {
        return mmld?.recent_mmld_meta
            ?.filter(obj => obj.DOCUMENT_TYPE === 'MEDICAL CERTIFICATE')
            ?.map(obb => {
                const expiresInDays =
                    (new Date(obb.DOCUMENT_EXPIRE_DT) - new Date()) /
                    (1000 * 3600 * 24);

                let color;
                if (expiresInDays < 30) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }

                return {
                    name: 'National Medical',

                    issued: obb.DOCUMENT_ISSUED_DT,
                    renewBy: obb.DOCUMENT_EXPIRE_DT,
                    bgColor: color,
                };
            });
    };
    let filterNationalResult = filterNational(mmld) || [];

    //Below is 3rd Function used to get MMC Objects
    const filterMMC = mmld => {
        return mmld?.recent_mmld_meta
            ?.filter(obj => obj.DOCUMENT_TYPE === 'MMC')
            ?.map(obb => {
                const expiresInDays =
                    (new Date(obb.DOCUMENT_EXPIRE_DT) - new Date()) /
                    (1000 * 3600 * 24);

                let color;
                if (expiresInDays < 30) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }

                return {
                    name: 'MMC',
                    issued: obb.DOCUMENT_ISSUED_DT,
                    renewBy: obb.DOCUMENT_EXPIRE_DT,
                    bgColor: color,
                };
            });
    };
    let filterMmcResult = filterMMC(mmld) || [];

    //Below is 2nd Function used to get Supporting Document Objects except drug test
    const filterSupportingDocument = dataExpiration => {
        return dataExpiration?.supporting_document
            ?.filter(
                obj =>
                    obj.date_expired?.length > 0 &&
                    obj.date_expired !== null &&
                    obj.supporting_document_type !==
                        'DOT/ USCG Periodic Drug Test Document'
            )
            ?.map(obb => {
                let color;
                const expiresInDays =
                    (new Date(obb.date_expired) - new Date()) /
                    (1000 * 3600 * 24);

                if (expiresInDays < 30 && expiresInDays > 0) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }
                return {
                    name: obb.name,

                    issued: obb.date_issued,
                    renewBy: obb.date_expired,
                    bgColor: color,
                };
            });
    };
    let filterSupportingDocumentResult =
        filterSupportingDocument(dataExpiration) || [];

    // Below concat and sort all the arrays
    const output =
        filterStcwResult
            ?.concat(
                filterNationalResult,
                filterMmcResult,
                filterSupportingDocumentResult
            )
            ?.sort((elem1, elem2) => {
                if (elem1.renewBy < elem2.renewBy) {
                    return -1;
                }
                if (elem1.renewBy > elem2.renewBy) {
                    return 1;
                }
                return 0;
            }) || [];

    //////////////////////////////////////////////////

    const filterCpr = dataExpiration => {
        return dataExpiration?.cpr
            ?.filter(obj => obj.been_used_before === false)
            ?.map(ob => {
                const expiresInDays =
                    (new Date(ob.expiration_date) - new Date()) /
                    (1000 * 3600 * 24);

                let color;
                if (expiresInDays < 30 && expiresInDays >= 0) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }
                return {
                    document: 'CPR',
                    issued: ob.issue_date,
                    renewBy: ob.expiration_date,
                    bgColor: color,
                };
            });
    };
    let filterCprResult = filterCpr(dataExpiration) || [];

    //Below is 2nd Function used to get Drug Test Objects except drug test
    const filterDrugTest = dataExpiration => {
        return dataExpiration?.supporting_document
            ?.filter(
                obj =>
                    obj.date_expired !== null &&
                    obj.supporting_document_type ===
                        'DOT/ USCG Periodic Drug Test Document'
            )
            ?.map(obb => {
                let color;
                const expiresInDays =
                    (new Date(obb.date_expired) - new Date()) /
                    (1000 * 3600 * 24);

                if (expiresInDays < 30 && expiresInDays > 0) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }
                return {
                    document: obb.name,
                    issued: obb.date_issued,
                    renewBy: obb.date_expired,
                    bgColor: color,
                };
            });
    };
    let filterDrugTestResult = filterDrugTest(dataExpiration) || [];

    //Below is 3rd Function used to get Training Objects
    const filterTraining = dataExpiration => {
        return dataExpiration?.training
            ?.filter(obj => obj.been_used_before === false)
            ?.map(obb => {
                let color;
                const expiresInDays =
                    (new Date(obb.expiration_date) - new Date()) /
                    (1000 * 3600 * 24);
                if (expiresInDays < 30 && expiresInDays > 0) {
                    color = theme.palette.charts.lightRed;
                } else if (expiresInDays < 180 && expiresInDays >= 30) {
                    color = theme.palette.charts.lightOrange;
                } else {
                    color = theme.palette.charts.green;
                }
                return {
                    document: obb.course_name,
                    issued: obb.issue_date,
                    renewBy: obb.expiration_date,
                    bgColor: color,
                };
            });
    };
    let filterTrainingResult = filterTraining(dataExpiration) || [];

    const unsubmittedOutput =
        [...filterCprResult, ...filterTrainingResult, ...filterDrugTestResult]
            .filter(item => new Date(item.renewBy) > new Date())
            .sort((elem1, elem2) => {
                if (elem1.renewBy < elem2.renewBy) {
                    return -1;
                }
                if (elem1.renewBy > elem2.renewBy) {
                    return 1;
                }
                return 0;
            }) || [];

    return (
        <PageTab
            isLoading={isLoadingMmld || isLoadingExpiration}
            error={errorMmld || errorExpiration}
        >
            <WidgetCard title='' infoModalContent={''} hasData={mmld}>
                <Grid container>
                    <Grid item className={classes.gridWrapper}>
                        <Typography variant='h6'>Upcoming Dates</Typography>
                        <InfoModal content={content.upcomingDates} />
                    </Grid>
                    <TimeLeft />
                </Grid>
                <Grid container style={{marginTop: '3em'}}>
                    <Grid item className={classes.gridWrapper}>
                        <Typography variant='h6'>
                            Your Upcoming Expirations
                        </Typography>
                        <InfoModal content={content.upcomingExpirations} />
                    </Grid>

                    <TableContainer>
                        <Table
                            aria-label='Your Upcoming Expirations Table'
                            className={classes.table}
                        >
                            <TableHead>
                                <TableRow>
                                    <ColumnHeaders />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {output?.map((obj, i) => (
                                    <StyledTableRow
                                        hover
                                        key={`table-row-${i}`}
                                    >
                                        <TableCell
                                            className={classes.tableCell}
                                        >
                                            {obj.name}
                                        </TableCell>
                                        <TableCell
                                            className={classes.tableCell}
                                        >
                                            {moment(obj.issued).format(
                                                'MMM D, YYYY'
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={classes.tableCell}
                                            style={{
                                                backgroundColor: obj.bgColor,
                                            }}
                                        >
                                            {' '}
                                            {moment(obj.renewBy).format(
                                                'MMM D, YYYY'
                                            )}
                                        </TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid container style={{marginTop: '3em'}}>
                    <Grid item className={classes.gridWrapper}>
                        <Typography variant='h6'>
                            Your Unsubmitted Documents
                        </Typography>
                        <InfoModal content={content.unsubmittedDocuments} />
                    </Grid>

                    <TableContainer>
                        <Table
                            aria-label='Your Unsubmitted Documents Table'
                            className={classes.table}
                        >
                            <TableHead>
                                <TableRow>
                                    <UnsubmittedColumnHeaders />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {unsubmittedOutput?.map((obj, i) => (
                                    <StyledTableRow
                                        hover
                                        key={`table-row-${i}`}
                                    >
                                        <TableCell
                                            className={
                                                classes.unsubmittedTableCell
                                            }
                                        >
                                            {obj.document}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.unsubmittedTableCell
                                            }
                                        >
                                            {moment(obj.issued).format(
                                                'MMM D, YYYY'
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={
                                                classes.unsubmittedTableCell
                                            }
                                            style={{
                                                backgroundColor: obj.bgColor,
                                            }}
                                        >
                                            {moment(obj.renewBy).format(
                                                'MMM D, YYYY'
                                            )}
                                        </TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </WidgetCard>
        </PageTab>
    );
};

export default SeaServiceUpcomingDates;
export {StyledTableRow};
